import.meta.glob(["./js/**/*.{js, ts, css, scss}",
    "!./js/editor.js",
    // "!./js/interactive-calendar.js",
    "!./js/membership-application-pdf.js",
    "!./js/dynamic-youtube-gtm-tracking.js",
    "!./js/epiforms.js",
    "!./js/epiforms-helper.js",
    "!./js/login-datalayer-event.js",
    "!./js/inert.min.js"
], {
    eager: true
})

// The inert polyfill installs unconditionally and stamps aria-hidden="true" onto
// inert subtrees. It runs before React hydrates, so React sees the mutated DOM as
// server markup that doesn't match its own render. Native inert hides the subtree
// from assistive tech on its own and needs no such attribute, so only load the
// polyfill where inert is actually missing.
if (!("inert" in HTMLElement.prototype)) {
    import("./js/inert.min.js");
}

import "./app.scss";

function loadEpiformsIfPresent() {
    if (!document.querySelector(".EPiServerForms")) return;
    Promise.all([
        import("./js/epiforms.js"),
        import("./js/epiforms-helper.js"),
    ]).then(([{ default: epiforms }]) => epiforms());
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", loadEpiformsIfPresent);
} else {
    loadEpiformsIfPresent();
}
